import { API_URLS } from "../constants";
import { getRequest, postRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const { SURVEY } = API_URLS;

const getArchiveQuestionsByBrandId = (brandId) => {
  return getRequest(`${SURVEY.ARCHIVED_QUESTIONS}/${brandId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const reActivateArchivedQuestion = (brandId, questionId) => {
  return postRequest(
    `${SURVEY.REACTIVATE_ARCHIVED_QUESTION}/${brandId}/${questionId}`,
    {}
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const archivedQuestionsSerive = {
  reActivateArchivedQuestion,
  getArchiveQuestionsByBrandId,
};
